import { render, staticRenderFns } from "./PartDefectChart.vue?vue&type=template&id=121b93e0&scoped=true&"
import script from "./PartDefectChart.vue?vue&type=script&lang=js&"
export * from "./PartDefectChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "121b93e0",
  null
  
)

export default component.exports